"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = _default;

var _color = _interopRequireDefault(require("color"));

function _default(palette) {
  return {
    display: 'block',
    width: 'auto',
    borderColor: palette.elPrimary,
    boxShadow: "0 8px 12px 0 ".concat(palette.elShadow, ", 0 6px 12px 0 ").concat(palette.elShadow),
    background: palette.elPrimary,
    color: palette.tInactive,
    linkColor: palette.tAccent,
    zIndex: palette.zOverlay,
    labelFontSize: palette.tsXSmall,
    labelLineHeight: palette.tlXSmall,
    triangleWidth: palette.gutter / 2,
    textAlign: 'left',
    // hint offset relative to current position
    top: 0,
    left: 0,
    maxWidth: palette.gutter * 30 + 'px',
    minWidth: palette.gutter * 20 + 'px',
    darkBackground: (0, _color["default"])(palette.elBlack).hex(),
    darkBorderColor: (0, _color["default"])(palette.elBlack).hex(),
    darkColor: palette.tInversion
  };
}